<template>
  <div class="businessList">
    <div class="noData" v-if="nodata || searchResult || tenderLoad">
      <div class="noDataCon" v-if="nodata">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/noData.png" alt="">
        <p>暂无数据</p>
      </div>
      <div class="noDataSearch" v-else-if="searchResult">
        <h4>“{{keySearch}}”相关的搜索结果</h4>
        <p>共0个搜索结果，您可以尝试其他搜索词</p>
      </div>
      <div class="loadingBox" v-loading="tenderLoad"></div>
    </div>
    <ul class="clearfix" v-show="!tenderLoad">
      <li class="col-xs-12 col-sm-6 col-md-4 col-lg-4" v-for="(item,index) in businessList.epsPurchaseBulletinExtList" :key="index">
        <div class="businessBg">
          <div class="businessTop" @click="viewBussiness(viewInquiryUrl,item.projectId)">
            <h4 style="-webkit-box-orient: vertical;" v-html="antiCreeping(item.projectName)">{{item.projectName}}</h4>
            <p v-html="antiCreeping(item.quotationEndTime,'截止日期：')"></p>
          </div>
          <div class="businessBottom" @click="viewBussiness(viewInquiryUrl,item.projectId)">
            <p><span>发布日期：</span><b style="font-weight: normal" v-html="antiCreeping(item.publishTime,' ')"></b></p>
            <p><span>招标主体：</span><b style="font-weight: normal"  v-html="antiCreeping(item.purchaserOrgName)"></b></p>
          </div>
          <div class="businessBox8"><p></p></div>
          <div class="businessBox16"><p></p></div>
        </div>
      </li>
    </ul>
    <!-- <v-bootPage class="hidden-xs hidden-sm" v-ref:page :async="false" :data="businessList" :lens="lenArr" :page-len="pageLen" :param="param"></v-bootPage> -->
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { mapState } from 'vuex'

export default {
  props: ['businessList','viewInquiryUrl','customerPageUrl','tenderLoad','keySearch','searchResult','nodata'],
  data () {
    return {
      accessToken:''
    }
  },
  components: {
  },
  computed: mapState([
    'KP'
  ]),
  created () {
    if(this.getToken('isLogin') == 100){
      this.accessToken = Cookies.get('accessToken');
      this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
    }
  },
  methods:{
    async viewBussiness(url,projectId){
      try {
        await this.$store.dispatch('findWebDtoHandler');
      } catch (e) {}

       if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
          this.$alert('<p>请登录pc端完善企业信息</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
        } else {
          this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
              cancelButtonClass:'cancelBtn',
              customClass:'mobileText',
              cancelButtonText: '以后再说',
              confirmButtonText: '点我补全',
              center: true
            }).then(() => {
              this.$router.push({path:'/inforPerfection'});
            }).catch(() => {
                this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
                }).then((res) => {
                  this.data = res.data;
                  this.removeCookie('TALK_LATER_'+this.data.userId);
                  this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
                });
            });
        }

      }else{
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/getUrlSignature?url='+url+projectId+'&accessToken='+this.accessToken, {
        }).then((res) => {
          this.data = res.data;
          // this.$router.push({path:'/recruit',query:{redirctUtl:this.data}})
          window.location.href =  this.data;
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/businessList/index.vue